<template>
  <div v-if="show">
    <div v-show="sizeErrorList.length && autoCropImageParams"><el-button type="link" @click="fixImgSize()">一键修正尺寸不符图片</el-button></div>
    <div v-loading="validating" :class="containerClasses" >
      <Upload
        v-for="(file, index) in merge_fileList"
        ref="imgs"
        :originFile="file"
        :outerId="effectiveOuterId"
        :isMainImg="index < mainImgNums"
        :imgName="imgNames[index]"
        :key="`${file.id}-${index}`"
        :file="file.file"
        :validated.sync="validatedMap[file.id]"
        :valiErrMsg.sync="valiErrMsgMap[file.id]"
        :draggable="true"
        :mainImgSortNum="getMainImgSortNum(index)"
        :index="index"
        :limitSize="limitSize"
        :size="size"
        :limitWidth="limitWidth"
        :limitHeight="limitHeight"
        :aspectRatio="aspectRatio"
        :aspectRatioRange="aspectRatioRange"
        :aspectRatioText="aspectRatioText"
        :aspectRatioLimitWidth="aspectRatioLimitWidth"
        :limitSuffix="limitSuffix"
        :uploadFunc="uploadFunc"
        :isSquare="isSquare"
        :needAutoCrop="needAutoCrop"
        :cropDefaultSize="cropDefaultSize"
        :show-audit-result="showAuditResult"
        :auditFileList="auditFileList"
        :showSettingSearchImgBtn="showSettingSearchImgBtn"
        :colorId="colorId"
        :isCheckImg="isCheckImg"
        :supportAiRetry="supportAiRetry"
        :fixImgCache="fixImgCache"
        :appendToBody="appendToBody"
        @upload-success="url => handleUploadSuccessWithIndex(url, index)"
        @set-as-specification="updateControlHighlightStatus"
        @set-as-search-img="updateControlSearchImg"
        @del="() => handleDelete(index)"
        @change="file => handleFileChange(file, index)"
        />
      <Upload
        v-if="showUploadButton"
        :emptyError="emptyError"
        :limitSuffix="limitSuffix"
        :uploadFunc="uploadFunc"
        :isSquare="isSquare"
        :cropDefaultSize="cropDefaultSize"
        :show-audit-result="showAuditResult"
        :auditFileList="auditFileList"
        :colorId="colorId"
        :appendToBody="appendToBody"
        :outerId="effectiveOuterId"
        @change="handleChange"
        @upload-success="handleUploadSuccess"
        @set-as-specification="updateControlHighlightStatus"
        @set-as-search-img="updateControlSearchImg"
      />
    </div>
  </div>
</template>

<script>
import Upload from './ImgUpload.vue'
import _ from 'lodash'
import { batchFixImages } from '@/servers/prod/center/index'
export default {
  inject: {
    elFormItem: { default: null },
    injectedOuterId: { default: () => '', from: 'outerId' },
  },
  model: {
    prop: "imgs",
    event: "change"
  },
  components: {
    Upload
  },
  props: {
    colorId: {
      type: String,
      default: ''
    },
    mainImgNums: {
      type: Number,
      default: 5
    },
    imgs: Array,
    imgNames: { 
      type: Array,
      default() {
        return []
      } 
    },
    limitSize: { // 字节大小限制
      type: Number,
      default: 0
    },
    size: { // 处理 oss 图片url,缩略图尺寸
      type: Number,
      default: 0
    },
    limitWidth: { // 限制宽度
      type: Array,
      default() {
        return [0, 0]
      } 
    },
    limitHeight: { // 限制高度
      type: Array,
      default() {
        return [0, 0]
      } 
    },
    aspectRatioRange: { 
      type: Array,
      default() { // 0表示不限制
        return [0, 0]
      } 
    },
    aspectRatio: { // 长宽比 width/height
      type: [Number, Array],
      default: 0
    },
    aspectRatioText: { // 长宽比文案
      type: String,
      default: ''
    },
    aspectRatioLimitWidth: { // 限制了长宽比时，不同宽高比的宽度限制
      type: Array,
      default() { 
        return []
      } 
    },
    limitSuffix: { // 图片后缀类型 英文逗号拼接
      type: String,
      default: '.jpg,.jpeg,.png,.gif'
    },
    limitNums: { // 限制图片数量
      type: Number,
      default: 0
    },
    uploadFunc: {
      type: Function
    },
    isSquare:{
      type:Boolean,
      default:false
    },
    cropDefaultSize: {
      type: Array,
      default: () => {
        return [800, 800]
      }
    },
    showAuditResult: {
      type: Boolean,
      default: false
    },
    auditFileList: {
      type: Array,
      default: () => {
        return []
      }
    },
    needAutoCrop: {
      type: Boolean,
      default: false
    },
    isSort: { // 是否支持图片拖拽排序
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    outerId: {
      type: String,
      default: ''
    },
    supportAiRetry: {
      type: Boolean,
      default: false
    },
    showSettingSearchImgBtn: {
      type: Boolean,
      default: false
    },
    isCheckImg:{
      type: Boolean,
      default: true
    },
    isSort: { // 是否支持图片拖拽排序
      type: Boolean,
      default: true
    },
    filterEmptyFile: { // 是否要过滤下空链接
      type: Boolean,
      default: true
    },
    autoCropImageParams:{ // 一键修正图片请求参数
      type: [Object,null],
      default: () => {
        return null
      }
    },
    emptyError:{ // 为空时报错提示
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      fileList: [],
      mainImgList: [],
      sortable: null,
      errmsgIns: null,
      show: true,
      validating: false,
      validatedMap: {},
      valiErrMsgMap: {},
      fixImgCache:{}, // 一键修改图片后缓存一下老的图片, key:新地址 value: 老地址
    }
  },
  computed: {
    effectiveOuterId() {
      const val = this.outerId || (typeof this.injectedOuterId === 'function' ? this.injectedOuterId() : this.injectedOuterId)
      return typeof val === 'string' ? val : ''
    },
    // 缓存合并后的文件列表，避免频繁重新计算
    merge_fileList: {
      get() {
        // 使用缓存的ID生成函数
        const genId = this.genIdMemoized;
        const validatedMap = {};
        const valiErrMsgMap = {};
        
        // 合并主图和附图列表
        const combinedList = this.mainImgList.concat(this.fileList);
        const arr = combinedList.map(item => {
          const id = genId(item);
          validatedMap[id] = this.validatedMap[id] || false;
          valiErrMsgMap[id] = this.valiErrMsgMap[id] || '';
          return { file: item, id };
        });
        
        // 批量更新验证状态
        this.validatedMap = validatedMap;
        this.valiErrMsgMap = valiErrMsgMap;
        return arr;
      },
      set(v) {
        const fileArr = v.map(item => item.file);
        let _mainImgList = fileArr.slice(0, this.mainImgNums);
        
        // 优化数组填充逻辑
        const remainingSlots = this.mainImgNums - _mainImgList.length;
        if (remainingSlots > 0) {
          _mainImgList = _mainImgList.concat(new Array(remainingSlots).fill(''));
        }
        
        this.mainImgList = _mainImgList;
        this.fileList = fileArr.slice(this.mainImgNums).filter(Boolean);
      }
    },
    
    // 缓存ID生成函数
    genIdMemoized() {
      return _.memoize((file) => {
        if (!file) return _.random(1, 9999);
        if (typeof file === 'string') return file;
        return file.name;
      });
    },
    
    // 预计算已存在图片数量
     existingImagesCount() {
       return this.merge_fileList.reduce((count, file) => {
         return file.file ? count + 1 : count;
       }, 0);
     },
     
     // 优化容器样式类计算
     containerClasses() {
       return [
         'muti-upload',
         { 'search-img-upload': this.showSettingSearchImgBtn }
       ];
     },
     
     // 优化上传按钮显示逻辑
     showUploadButton() {
       return !this.limitNums || (this.limitNums && this.merge_fileList.length < this.limitNums);
     },
     sizeErrorList(){
        let errorList = [];
        for(let key in this.valiErrMsgMap){
          let error = this.valiErrMsgMap[key];
          const regex = /宽度|长度|长宽/;
          if(regex.test(error)){
            errorList.push(key);
          }
        }
        return errorList
     },
   },
  watch: {
    imgs: {
      immediate: true,
      handler(v) {
        if (!v) v = [];
        // 优化主图列表更新
        this.mainImgList = new Array(this.mainImgNums).fill('').map((_, i) => v[i] || '');
        
        // 优化附图列表更新
        const additionalFiles = v.slice(this.mainImgNums);
        this.fileList = this.filterEmptyFile ? additionalFiles.filter(Boolean) : additionalFiles;
      }
    },
    
    // 监听主图数量变化，重新初始化
    mainImgNums: {
      handler() {
        this.$nextTick(() => {
          if (this.isSort) {
            this.init_sortable();
          }
        });
      }
    }
  },
  methods: {

    // 使用防抖优化更新频率
     updateData: _.debounce(function() {
       this.model_change();
       this.emitValidate();
     }, 16), // 约60fps的更新频率
    /**
     * 强制刷新，防止在最后的上传按钮，被排序到前面的图片之中
     */
    force_refresh() {
      this.show = false;
      this.sortable && this.sortable.destroy()
      this.$nextTick(() => {
        this.show = true;
        this.init_sortable();
      })
    },
    emitValidate() {
      if (!this.elFormItem) return ;
      setTimeout(() => {
        this.elFormItem && this.elFormItem.elForm.validateField(this.elFormItem.prop)
      }, 800);
    },
    // 优化事件处理器，减少内联函数创建
     handleDelete(index) {
       this.delFileList(index);
     },
     
     handleFileChange(file, index) {
       this.handleChange(file, index);
     },
     
     handleUploadSuccessWithIndex(url, index) {
       this.updateFileList(index, url);
     },
     
     handleChange(fileList, index) {
       // 使用预计算的图片数量，避免重复计算
       const exitNum = this.existingImagesCount;
       if (this.limitNums && (exitNum + fileList.length) > this.limitNums) {
         // 防止重复弹信息
         if (this.errmsgIns && !this.errmsgIns.closed) {
           return;
         }
         this.errmsgIns = this.$message.warning('图片已达到上限,请先移除超限图片');
         return;
       } 

      if (index < this.mainImgNums) {
        let _mainImgList = [];
         for(let mi = 0; mi < this.mainImgNums; mi++) {
          if (mi < index) {
            _mainImgList[mi] = this.mainImgList[mi];
            continue;
          }
          if (!this.mainImgList[mi] && fileList.length) {
            _mainImgList[mi] = fileList.shift();
          } else {
            _mainImgList[mi] = this.mainImgList[mi];
          }
        }
        if (fileList.length) {
          this.fileList = [...fileList, ...this.fileList];
        }
        this.mainImgList = _mainImgList;
      } else if(!this.filterEmptyFile) {
        let concatFileList = [...this.fileList];
        concatFileList[index] = fileList.shift();
        fileList.forEach(f => {
          const emptyIndex = concatFileList.findIndex(c => !c)
          if(emptyIndex > -1) {
            concatFileList[emptyIndex] = f
          } else {
            concatFileList.push(f)
          }
        })
        if(this.limitNums) {
          concatFileList = concatFileList.slice(0, this.limitNums)
        } 
        this.fileList = concatFileList
      } else {
        this.fileList = [...this.fileList, ...fileList];
      }
      this.updateData();
    },
    updateFileList(index, url) {
      if (index < this.mainImgNums) {
        // 主图区更新
        this.$set(this.mainImgList, index, url);
      } else {
        // 非主图更新
        this.$set(this.fileList, index - this.mainImgNums, url);
      }
      this.updateData();
      this.handleUploadSuccess(url);
    },
    updateControlHighlightStatus(checkedImgObj){
      this.$emit('imageUrlSetChanged', checkedImgObj)
    },
    // 修改搜索图内容
    updateControlSearchImg(checkedImgObj){
      this.$emit('imageUrlSetSearchChange', checkedImgObj)
    },
    handleUploadSuccess(url) {
      this.$emit('file-upload', url)
    },
    delFileList(index) {
      if (!this.filterEmptyFile) {
        this.$set(this.fileList, index, '');
      } else if (index < this.mainImgNums) {
        // 主图区删除：使用更高效的数组操作
        const newList = this.merge_fileList.slice();
        newList.splice(index, 1);
        this.merge_fileList = newList;
      } else {
        // 非主图删除
        this.fileList.splice(index - this.mainImgNums, 1);
      }
      this.updateData();
    },
    // 优化主图排序号计算，避免重复过滤
    getMainImgSortNum(index) {
      if (index >= this.mainImgNums) return false;
      
      // 检查是否有有效的主图
      const hasValidMainImg = this.mainImgList.some(item => 
        typeof item === 'string' && item
      );
      
      return hasValidMainImg ? index + 1 : false;
    },
    // 校验图片格式是否符合要求
    async method_validImage() {
      this.validating = true;
      
      try {
        const mainLen = this.mainImgNums;
        const imgRefs = this.$refs.imgs;
        
        if (!imgRefs || !imgRefs.length || !this.elFormItem) {
          return '';
        }
        
        if (this.limitNums && imgRefs.length > this.limitNums) {
          return `最多上传${this.limitNums}张图片,请先移除超限图片`;
        }
        
        // 使用Promise.all并行验证，提升性能
        const validationPromises = imgRefs.map(async (imgRef, i) => {
          if (!imgRef) return null;
          
          const errMsg = await imgRef.method_validImage();
          if (errMsg) {
            const isTypeError = /^图片类型只支持/.test(errMsg);
            const imgType = i < mainLen ? '主图' : '图片';
            const imgNum = i < mainLen ? imgRef.mainImgSortNum : imgRef.index + 1;
            const action = isTypeError ? '' : '或裁剪';
            return `${imgType}${imgNum || ''}${errMsg}，需移除${action}`;
          }
          return null;
        });
        
        const results = await Promise.all(validationPromises);
        const firstError = results.find(result => result !== null);

        return firstError || '';
      } catch (error) {
        console.error('图片验证出错:', error);
        return '图片验证失败，请重试';
      } finally {
        this.validating = false;
      }
    },
    getWidthAndHeights() {
      const imgRefs = this.$refs.imgs;
      if (!imgRefs?.length) return [];
      
      // 使用更高效的数组操作
      return imgRefs
        .map(imgRef => imgRef?.getWidthAndHeight())
        .filter(Boolean);
    },
    model_change(){
      // 触发v-model
      // 上传图片后
      // 拖拽排序后
      // 删除图片后
      const imgList = [...this.mainImgList, ...this.fileList]
      if(imgList.find(img => typeof img === 'object')) {
        return
      }
      this.$emit("change", imgList)
    },
    // 优化Sortable初始化，避免重复创建
    init_sortable() {
      if (this.sortable) {
        this.sortable.destroy();
      }
      
      this.$nextTick(() => {
        let target = this.$el.querySelector('.muti-upload');
        this.sortable = Sortable.create(target, {
          handle: ".file-img",
          draggable: '.draggable',
          animation: 150, // 添加动画提升用户体验
          onEnd: (evt) => {
            const { newIndex, oldIndex } = evt;
            const fileListCopy = [...this.merge_fileList];
            
            // 优化索引边界处理
            const targetIndex = Math.min(newIndex, fileListCopy.length - 1);
            
            // 使用更高效的数组操作
            const [movedFile] = fileListCopy.splice(oldIndex, 1);
            fileListCopy.splice(targetIndex, 0, movedFile);
            
            // 批量更新，减少重渲染
            this.$nextTick(() => {
              this.merge_fileList = fileListCopy;
              this.updateData();
            });
          }
        });
      });
    },
    async fixImgSize(){// 一键修正图片尺寸
      if(this.sizeErrorList.length){
          let maxRequestNum = 20; // 接口一次最大接受20张图
          let reqParams = this.sizeErrorList.map(url => {
            return {
                imageUrl:url,
                ...this.autoCropImageParams
            }
          });
          const batches = [];
          while(reqParams.length){
            let images = reqParams.splice(0,maxRequestNum);
            batches.push(batchFixImages({images}))
          }
          let batchResults = await Promise.all(batches);
          let newImg = [...this.imgs];
          batchResults = batchResults.reduce((acc, cur) => {
            acc.push(...cur);
            return acc;
          }, []);
          let newFixImgCache = {...this.fixImgCache}
          let errorList = [];
          batchResults.forEach(item => {
            let oldUrl = item.originalUrl
            let newUrl = item.processedUrl
            let errorText = item.errorMessage
            if(newUrl){
              // 替换修改后的图片
              let index = newImg.findIndex(img => img === oldUrl)
              if(index !== -1){
                newImg[index] = newUrl;
                newFixImgCache[newUrl] = oldUrl;
              }
            }
            if(errorText){
              errorList.push(errorText)
            }
          });
          if(errorList.length > 0 ){
            this.$message.error(errorList.join(';'))
          }
          // 存在成功的就更新
          if(errorList.length < batchResults.length){
            this.$emit("change", newImg)
            this.$nextTick(() => {
              this.updateData();//
            })
          }
          this.fixImgCache = newFixImgCache
      }
    }
  },
  created() {
     // 优化主图列表初始化
     const currentLength = this.mainImgList.length;
     if (currentLength < this.mainImgNums) {
       const emptySlots = new Array(this.mainImgNums - currentLength).fill('');
       this.mainImgList = this.mainImgList.concat(emptySlots);
     }
     
     // 冻结静态配置，提升性能
     if (this.cropDefaultSize) {
       Object.freeze(this.cropDefaultSize);
     }
     if (this.limitWidth) {
       Object.freeze(this.limitWidth);
     }
     if (this.limitHeight) {
       Object.freeze(this.limitHeight);
     }
   },
  
  mounted() {
    // 将Sortable初始化移到mounted，确保DOM已渲染
    if (this.isSort) {
      this.init_sortable();
    }
  },
  beforeDestroy() {
     // 清理资源，防止内存泄漏
     if (this.sortable) {
       this.sortable.destroy();
       this.sortable = null;
     }
     
     // 清理消息实例
     if (this.errmsgIns && !this.errmsgIns.closed) {
       this.errmsgIns.close();
     }
     
     // 清理防抖函数
     if (this.updateData && this.updateData.cancel) {
       this.updateData.cancel();
     }
   }
}
</script>

<style lang="scss" scoped>
.muti-upload {
  display: flex;
  flex-wrap: wrap;
  ::v-deep .el-loading-mask{
    display: none;
  }
}
.search-img-upload{
  margin-bottom: 20px!important
}
</style>